<!-- ===================================
     FILE 5: generatedcv.component.html (UPDATED)
     =================================== -->

<div class="cv-templates">
  <div class="cv-card" *ngFor="let cv of generatedCvs; let i = index">
    <div class="image-container">
      <div class="edit-cv-btn" *ngIf="cv.editable">
        <i class="bi bi-pencil-square mx-2" (click)="backToEdit(cv.id)"></i>
      </div>
      <img [src]="getImageUrl(cv.imagePath)" alt="{{ 'CV Template' | translate }} {{ i + 1 }}"
        (contextmenu)="disableRightClick($event)" />
    </div>

    <div class="buttons">
      <!-- PDF -->
      <ng-container *ngIf="cv.pdfPath; else buyPdfCondition">
        <button (click)="downloadFile(cv.pdfPath)" class="pdf_button">
          {{ 'Download PDF' | translate }}
        </button>
      </ng-container>

      <!-- Buy PDF only if Word exists -->
      <ng-template #buyPdfCondition>
        <button *ngIf="!cv.wordPath" (click)="makeOrder(cv.id,'generate-cv-pdf')" class="pdf_button">
          {{ 'Buy PDF' | translate }}
        </button>
      </ng-template>

      <!-- WORD -->
      <ng-container *ngIf="cv.wordPath">
        <button (click)="downloadFile(cv.wordPath)" class="pdf_button">
          {{ 'Download Word' | translate }}
        </button>
      </ng-container>

      <!-- Generate Cover Letter - Opens Popup -->

      <button *ngIf="cv.clGeneratable && (cv.pdfPath || cv.wordPath)" class="gcover-letter"
        (click)="openCoverLetterPopup(cv.id)">
        {{ 'Generate Cover Letter' | translate }}
      </button>

      <!-- Buy Word & PDF (when nothing exists) -->
      <button *ngIf="!cv.wordPath && !cv.pdfPath" (click)="makeOrder(cv.id,'generate-cv-word')" class="word_download">
        {{ 'Buy Word & PDF' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Cover Letter Popup Component -->
<app-cl-job-details-pop-up [isVisible]="showCoverLetterPopup" [cvId]="selectedCvId"
  (close)="closeCoverLetterPopup()"></app-cl-job-details-pop-up>